<template>
  <v-dialog v-model="dialogStatus" persistent width="600" attach="#appRoot">
    <v-card>
      <v-card-title class="headline accent white--text" primary-title>
        {{ propEventoObj.TitoloEvento }}
        <v-spacer></v-spacer>
        {{ propEventoObj.TipoEventoDescrizione }}
      </v-card-title>
      <v-card-text>
        <v-layout row mb-3>
          <small v-if="propEventoObj.DataApertura" class="primary--text">Data Apertura: {{ Util.formattaData(propEventoObj.DataApertura) }}</small>
          <v-spacer></v-spacer>
          <small v-if="propEventoObj.DataChiusura" class="red--text">Data Chiusura: {{ Util.formattaData(propEventoObj.DataChiusura) }}</small>
          <v-spacer></v-spacer>
          <small v-if="propEventoObj.AnnoSportivoDescrizione && propEventoObj.TipologiaEvento === 'Gara'" class="blue--text"
            >Anno Sportivo: {{ propEventoObj.AnnoSportivoDescrizione }}</small
          >
          <small v-else-if="propEventoObj.AnnoSportivoDescrizione" class="blue--text">Anno di riferimento: {{ propEventoObj.AnnoSportivoDescrizione }}</small>
        </v-layout>

        <v-layout row wrap>
          <v-flex v-if="imageObj.blobImage" xs12 sm4>
            <viewer
              :images="['data:' + imageMimeType + ';base64,' + imageObj.blobImage]"
              :options="{
                navbar: false,
                title: false,
                toolbar: false,
                tooltip: false,
                movable: true,
                zoomable: true,
                rotatable: false,
                scalable: false,
                transition: true,
                fullscreen: true,
                keyboard: true,
                url: 'data-source',
              }"
              class="text-xs-center"
            >
              <img :src="'data:' + imageMimeType + ';base64,' + imageObj.blobImage" width="100%" class="cursor-pointer" />
            </viewer>
          </v-flex>
          <v-spacer v-if="imageObj.blobImage"></v-spacer>
          <v-flex align-center justify-center>
            <v-chip small color="secondary" class="ml-0">{{ Util.formattaData(propEventoObj.DataEvento) }}</v-chip>
            <v-chip v-if="propEventoObj.StatoEvento === 'Chiuso'" small color="orange" class="ml-0">Evento chiuso</v-chip>
            <div v-text="propEventoObj.AssociazioneDenominazione" class="accent--text font-weight-bold py-2"></div>
            {{ propEventoObj.Indirizzo }}
            <br />
            {{ propEventoObj.Cap }} {{ propEventoObj.CittaIndirizzo }}
            <span v-if="propEventoObj.ProvinciaIndirizzo">({{ propEventoObj.ProvinciaIndirizzo }})</span>
            <span v-if="propEventoObj.LocalitaIndirizzo">- {{ propEventoObj.LocalitaIndirizzo }}</span>
            <div class="text-xs-right mt-3">
              <v-btn v-if="imageObj.blobImage" @click="downloadPDF()" flat> <v-icon left color="red">picture_as_pdf</v-icon>Scarica l'invito </v-btn>
            </div>
            <div class="text-xs-right mt-3">
              <v-btn v-if="propEventoObj.Piazzola" @click="downloadPiazzola(propEventoObj.id)" flat> <v-icon left color="brown">picture_as_pdf</v-icon>Scarica piazzole</v-btn>
            </div>
            <div
              v-if="(propEventoObj.TipoEventoCodice != 'CI_OUTDOOR' && propEventoObj.Classificati > 0) || propEventoObj.isClassificaCalcolata || propEventoObj.isClassificaPdf"
              class="text-xs-right mt-3"
            >
              <v-btn @click="exportClassifica(propEventoObj.id)" flat> <v-icon left color="primary">fa-trophy</v-icon>Scarica la classifica </v-btn>
            </div>
            <div v-if="(propEventoObj.Classificati == 0)" class="text-xs-right mt-3">
              <v-btn @click="downloadReportIscritti(propEventoObj.id)" flat> <v-icon left color="orange">picture_as_pdf</v-icon>Scarica il report iscritti </v-btn>
            </div>

            <div v-if="propEventoObj.TipologiaEvento === 'Gara'" class="text-xs-right mt-2">
              <v-chip v-if="propEventoObj.isOpen" small color="blue lighten-2" text-color="white">Open</v-chip>
              <div v-else>
                <v-chip small color="red lighten-2" text-color="white">Consentito solo agli iscritti</v-chip>
              </div>
            </div>
          </v-flex>
        </v-layout>

        <h4 v-if="propEventoObj.IsIscritto" class="red--text font-weight-bold text-xs-center mt-2">
          <v-icon color="red" class="mr-1">star</v-icon>
          {{ propEventoObj.StatoIscrizione }}
          <v-icon color="red">star</v-icon>
        </h4>
        <div class="py-3">{{ propEventoObj.DescrizioneEvento }}</div>
        <v-layout v-if="propEventoObj.Classificati == 0" row justify-center align-center>
          <v-chip small color="blue-grey lighten-2" text-color="white">
            <v-avatar class="blue-grey darken-1">{{ propEventoObj.Prenotati }}</v-avatar
            >Prenotati
          </v-chip>
          <v-chip small color="orange lighten-2" text-color="white">
            <v-avatar class="orange darken-1">{{ propEventoObj.ListaAttesa }}</v-avatar
            >Lista d'attesa
          </v-chip>
          <v-chip small color="grey" text-color="white">
            <v-avatar class="grey darken-2">{{ propEventoObj.Iscritti }}</v-avatar
            >Iscritti
          </v-chip>
        </v-layout>
        <v-layout row justify-center align-center>
          <v-chip v-if="propEventoObj.Classificati == 0" small color="primary" text-color="white">
            <v-avatar class="primary darken-4">{{ propEventoObj.TotalePartecipanti }}</v-avatar
            >Totale Partecipanti
          </v-chip>

          <v-chip v-else small color="primary" text-color="white">
            <v-avatar class="primary darken-4">{{ propEventoObj.Classificati }}</v-avatar
            >Totale Partecipanti
          </v-chip>
        </v-layout>
        <v-layout column my-3>
          <strong>RIFERIMENTI:</strong>
          <div>
            <v-icon small class="mr-1">mail</v-icon>
            {{ propEventoObj.EmailRiferimento }}
          </div>
          <div>
            <v-icon small class="mr-1">phone</v-icon>
            {{ propEventoObj.Telefono }}
          </div>
        </v-layout>
      </v-card-text>
      <v-card-actions class="grey lighten-3">
        <v-btn @click="closeDialog" flat>Chiudi</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="showPrenota(propEventoObj)" @click="showPrenotazioneDialog(propEventoObj)" color="primary">Prenota</v-btn>
        <v-btn
          v-else-if="
            showAnnulla &&
            propEventoObj.abilitatoPrenotazione &&
            propEventoObj.IsIscritto &&
            checkFunzione(elencoFunzioni.CANCELLAZIONE_PRENOTAZIONE_EVENTO) &&
            propEventoObj.StatoIscrizione == 'Prenotato'
          "
          @click="dialogAnnullamenoOpen(propEventoObj, 0)"
          color="red white--text"
          small
          flat
          >Annulla Prenotazione</v-btn
        >
        <v-btn
          v-else-if="
            showAnnulla &&
            propEventoObj.abilitatoPrenotazione &&
            propEventoObj.IsIscritto &&
            checkFunzione(elencoFunzioni.CANCELLAZIONE_PRENOTAZIONE_EVENTO) &&
            propEventoObj.StatoIscrizione == 'Iscritto'
          "
          @click="dialogAnnullamenoOpen(propEventoObj, 1)"
          color="red white--text"
          small
          flat
          >Annulla Iscrizione</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialogAnnullameno" persistent max-width="490">
      <v-card>
        <v-card-title class="display-1 font-weight-bold red white--text">Annullamento {{ annullaItem }}</v-card-title>
        <v-card-text class="headline">Sei sicuro di voler annullare {{ annullaText }}?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogAnnullameno = false" color="red white--text" class="btnDefault" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="annullaPrenotazione(eventoObj)" color="green white--text" dark> <v-icon small left>check</v-icon>si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Util from '@/util';
  import store from '@/store/store';
  import { bus } from '@/main';
  import Security from '@/security';
  import ImageEntity from '@/pages/anagrafica/generale/ImageEntity';
  import InvitoEntity from '@/pages/eventi/generale/InvitoEntity';
  import 'viewerjs/dist/viewer.css';
  import Viewer from 'v-viewer';
  import Vue from 'vue';
  import * as moment from 'moment';
  Vue.use(Viewer);

  export default {
    props: ['propEventoObj', 'propStatus', 'propImage', 'propIscrizioneObj'],
    data: () => ({
      Util,
      elencoFunzioni: Security.enFunzione,
      ruoliUtente: Security.ruolo,
      dialogStatus: false,
      dialogAnnullameno: false,
      imageObj: new ImageEntity(),
      invitoObj: new InvitoEntity(),
      viewerImg: null,
      annullaItem: '',
      annullaText: '',
    }),

    computed: {
      ...mapGetters(['userData']),
      ...mapGetters('eventiModule', ['getInvito']),
      invito() {
        return this.getInvito;
      },
      showAnnulla() {
        let retVal = false;
        if (this.propEventoObj && this.userData.tipoAccesso && this.userData.tipoAccesso == 'WEB') {
          const dataEvento = moment(this.propEventoObj.DataEvento);
          const dataAnnullamento = dataEvento.subtract(15, 'day');
          retVal = moment(new Date()).isSameOrBefore(dataAnnullamento);
        }
        return retVal;
      },
    },

    watch: {
      propStatus(val, oldVal) {
        this.dialogStatus = val;
        delete this.invitoObj.blobImage;
      },
      propImage() {
        this.imageObj = new ImageEntity(this.propImage);
        this.imageMimeType = Util.guessImageMime(this.propImage);
      },
    },

    methods: {
      ...mapActions('eventiModule', ['loadInvito', 'exportClassificaPDF', 'updatePartecipazione', 'loadPiazzola', 'stampaReportIscrittiAsync']),
      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },

      downloadFromWebview(url) {
        window.flutter_inappwebview.callHandler(
          'MobileDownload',
          JSON.stringify({
            urlToDownload: url,
          }),
        );
      },
      downloadPDF() {
        if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'WEB') {
          this.loadInvito(this.propEventoObj.id);
        } else if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'APP') {
          this.downloadFromWebview('/eventi/' + this.propEventoObj.id + '/invito');
        }
      },

      downloadReportIscritti(idEvento) {
        if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'WEB') {
          this.stampaReportIscrittiAsync(idEvento);
        } else if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'APP') {
          this.downloadFromWebview('/eventiview/' + idEvento + '/reportIscrizioni');
        }
      },

      manageClassifica(idEvento) {
        this.$router.push({ name: 'eventi/calendario/classifica', params: { idEvento: idEvento } });
      },

      exportClassifica(idEvento) {
        const vm = this;
        if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'WEB') {
          vm.exportClassificaPDF(idEvento);
        } else if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'APP') {
          vm.downloadFromWebview('/classificaview/' + idEvento + '/classifica');
        }
      },

      downloadPiazzola(idEvento) {
        const vm = this;
        if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'WEB') {
          vm.loadPiazzola(idEvento);
        } else if (this.userData.tipoAccesso && this.userData.tipoAccesso == 'APP') {
          vm.downloadFromWebview('/eventi/' + idEvento + '/piazzola');
        }
      },

      closeDialog(event) {
        bus.$emit('close-dettaglioDialog', false);
      },

      isIscrittoFederazione(func) {
        return !this.userData.Open;
      },
      showIscrivi(evt) {
        return this.userData.tipoAccesso && this.userData.tipoAccesso == 'WEB' && evt.abilitatoIscrizione && this.checkFunzione(this.elencoFunzioni.ISCRIZIONE_EVENTO_ASSOCIAZIONE);
      },

      showPrenota(evt) {
        let prenota = true;
        let open = true;

        if (evt.TipologiaEvento === 'Didattico' && this.userData.AssociazioneId != evt.AssociazioneId) {
          prenota = false;
        } else {
          open = evt.isOpen || (evt.isOpen == false && !this.userData.Open);
        }

        return (
          this.userData.tipoAccesso &&
          this.userData.tipoAccesso === 'WEB' &&
          evt.abilitatoPrenotazione &&
          this.userData.Role === this.ruoliUtente.ASSOCIATO &&
          this.checkFunzione(this.elencoFunzioni.INSERIMENTO_PRENOTAZIONE_EVENTO) &&
          !evt.IsIscritto &&
          open &&
          prenota
        );
      },

      showPrenotazioneDialog(evt) {
        bus.$emit('open-prenotazioneDialog', evt);
        bus.$emit('close-dettaglioDialog');
      },

      dialogAnnullamenoOpen(item, x) {
        const vm = this;
        vm.eventoObj = item;

        if (x == 0) {
          this.annullaItem = 'prenotazione';
          this.annullaText = 'la prenotazione';
        } else {
          this.annullaItem = 'iscrizione';
          this.annullaText = "l' iscrizione";
        }
        vm.dialogAnnullameno = true;
      },

      annullaPrenotazione(evt) {
        const vm = this;
        this.propIscrizioneObj = {
          Id: evt.iscrizioneId,
          IdEvento: evt.id,
          StatoIscrizione: 'Annullato',
        };
        this.updatePartecipazione(this.propIscrizioneObj).then(() => {
          vm.dialogAnnullameno = false;
          bus.$emit('close-dettaglioDialog');
        });
      },
    },
  };
</script>
